import React from "react";
import { useNavigate } from "react-router-dom";
import { Bookmark } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { track } from "@/lib/analytics";
import { useFavourites } from "@/context/FavouritesContext";

export const FavouriteButton = ({ factId, variant = "icon", date, category }) => {
  const { user } = useAuth();
  const { isFav, toggle } = useFavourites();
  const navigate = useNavigate();
  const active = isFav(factId);

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      toast.info("Sign in to save this — no password needed");
      navigate("/login", { state: { from: window.location.pathname } });
      return;
    }
    toggle(factId);
    if (!active) track("event_saved", { date: date || "", category: category || "event", event_id: factId });
    toast.success(active ? "Removed from Saved" : "Saved — find it under Saved");
  };

  if (variant === "inline") {
    return (
      <button
        data-testid={`fav-btn-${factId}`}
        onClick={onClick}
        title={active ? "Remove from saved" : "Save"}
        aria-label={active ? "Remove from saved" : "Save"}
        className={`ml-auto p-1.5 rounded-lg transition-colors ${active ? "text-gold" : "text-ink-muted hover:text-gold"}`}
      >
        <Bookmark className={`w-4 h-4 ${active ? "fill-current" : ""}`} />
      </button>
    );
  }

  if (variant === "pill") {
    return (
      <button
        data-testid={`fav-btn-${factId}`}
        onClick={onClick}
        className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full font-mono text-sm border transition-all ${active ? "bg-ink text-white border-gold" : "bg-white text-ink border-slate-300 hover:border-gold hover:text-gold"}`}
      >
        <Bookmark className={`w-4 h-4 ${active ? "fill-current" : ""}`} /> {active ? "Saved" : "Save"}
      </button>
    );
  }

  return (
    <button
      data-testid={`fav-btn-${factId}`}
      onClick={onClick}
      title={active ? "Remove from favourites" : "Save to favourites"}
      className={`absolute top-3 right-3 z-10 p-2 rounded-full backdrop-blur border transition-colors ${active ? "bg-ink text-white border-gold" : "bg-white/90 text-ink-muted border-slate-200 hover:text-gold hover:border-gold"}`}
    >
      <Bookmark className={`w-4 h-4 ${active ? "fill-current" : ""}`} />
    </button>
  );
};
